import React from 'react'
import pure from 'recompose/pure'
import SvgIcon from '../../SvgIcon'

let Tartrazine = props => (
  <SvgIcon {...props}>
    <text x="12" y="12" fontSize="10" textAnchor="middle" dominantBaseline="middle">
      E102
    </text>
  </SvgIcon>
)
Tartrazine = pure(Tartrazine)
Tartrazine.displayName = 'Tartrazine'
Tartrazine.muiName = 'SvgIcon'

export default Tartrazine
